export { default } from './parts-availablity-wrapper';
